import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';
import { ClientFactories, Store } from 'bernie-plugin-mobx';
import { ClientLogger } from 'bernie-client';

import { ConfigStore } from './config-store';

export const stores: ClientFactories = {
  config: (): Store => new ConfigStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.config')),
  advertising: (): Store => new AdvertisingStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.ads'))
};
